import React, { useState, useEffect } from "react";
import "./weekpicker.css";
import { v4 } from "uuid";
import { ArrowLeft } from "./ArrowLeft";
import { ArrowRight } from "./ArrowRight";
import { addMonths, endOfWeek, startOfWeek, subMonths } from "date-fns";
import { getDaysInMonth } from "date-fns/esm";
import moment from "moment";
import { getWeekNumber } from "../../../../utils/helperFunctions";

export const WeekPicker = ({ onChange,scenario,openLeft, inicio, base, original, simulated, dataPlanificacion,edited, flagWeek, setFlagWeek, date, setDate, week, setWeek }:any) => {
  
const [open, setOpen] = useState(false);
  


  useEffect(() => {
      getDateFromWeekNumber(week.firstDay.getFullYear(),getWeekNumber(week.firstDay) - 1)
  }, [])

  const isLeapYear = () => {
    let leapYear = new Date(new Date().getFullYear(), 1, 29);
    return leapYear.getDate() == 29;
  };

  const convertDate = (date:any) => {
    let dt = new Date(date);
    const day = dt.getDate().toString().padStart(2, '0'); // Agrega el cero delante si es necesario
    const month = (dt.getMonth() + 1).toString().padStart(2, '0'); // Agrega el cero delante si es necesario

    return `${day}.${month}.${dt.getFullYear()}.`;
  };

  const getDateFromWeekNumber = (year:any,weekNumber:any) => {
    // Create a date for the first day of the year
    const januaryFirst = new Date(year ?? new Date().getFullYear(), 0, 1);

    // Calculate the day of the week (0-6, where 0 is Sunday and 6 is Saturday)
    const dayOfWeek = januaryFirst.getDay();

    // Calculate the offset to the Thursday of the same week as January 4th
    
    const offset = (weekNumber?? moment().week() - 1) * 7 + (4 - dayOfWeek);

    // Create the date by adding the offset to January 4th
    const result = new Date(year ?? new Date().getFullYear(), 0, 1 + offset);

    setDate(result)
    setWeek({
        firstDay: startOfWeek(result,{weekStartsOn:1}),
        lastDay: endOfWeek(result,{weekStartsOn:1})
    })
  }

  const handleClick = (e:any) => {
    
    let localDate;
    if (e.target.id.includes("prev")) {
      localDate = new Date(date.setDate(1));
      setDate(new Date(date.setDate(1)));
    } else if (e.target.id.includes("next")) {
      localDate = new Date(date.setDate(getDaysInMonth(date)));
      setDate(new Date(date.setDate(getDaysInMonth(date))));
    } else {
      localDate = new Date(date.setDate(e.target.id));
      setDate(new Date(date.setDate(e.target.id)));
    }
    const firstDay = startOfWeek(localDate, { weekStartsOn: 1 });
    const lastDay = endOfWeek(localDate, { weekStartsOn: 1 });
    setWeek({ firstDay, lastDay });
    onChange({ firstDay, lastDay },inicio,base,scenario)
  };

  const months:any = [
    "Ene.",
    "Feb.",
    "Mar.",
    "Abril.",
    "Mayo",
    "Jun",
    "Jul",
    "Ago.",
    "Sep.",
    "Oct.",
    "Nov.",
    "Dic."
  ];

  const days:any = {
    "1": 31,
    "2": isLeapYear() ? 29 : 28,
    "3": 31,
    "4": 30,
    "5": 31,
    "6": 30,
    "7": 31,
    "8": 31,
    "9": 30,
    "10": 31,
    "11": 30,
    "12": 31
  };

  const renderDays = () => {
    let month = date.getMonth() + 1;
    let ar = [];
    for (let i:any = 1; i <= days[month]; i++) {
      let currentDate = new Date(date).setDate(i);

      let cName = "single-number ";
      if (
        new Date(week.firstDay).getTime() <= new Date(currentDate).getTime() &&
        new Date(currentDate).getTime() <= new Date(week.lastDay).getTime()
      ) {
        cName = cName + "selected-week";
      }

      ar.push(
        <div key={v4()} id={i} className={cName} onClick={handleClick}>
          {i}
        </div>
      );
    }

    const displayDate = new Date(date).setDate(1);
    let dayInTheWeek = new Date(displayDate).getDay();
    if (dayInTheWeek < 1) {
      dayInTheWeek = 7;
    }
    let prevMonth = [];
    let prevMonthDays = new Date(date).getMonth();
    if (prevMonthDays === 0) {
      prevMonthDays = 12;
    }
    for (let i = dayInTheWeek; i > 1; i--) {
      let previousMonth = new Date(date).setMonth(
        new Date(date).getMonth() - 1
      );
      let currentDate = new Date(previousMonth).setDate(
        days[prevMonthDays] - i + 2
      );
      let cName = "single-number other-month";
      let currentTime = new Date(currentDate).getTime();
      let firstTime = new Date(week.firstDay).getTime();
      let endTime = new Date(week.lastDay).getTime();
      if (currentTime >= firstTime && currentTime <= endTime) {
        cName = "single-number selected-week";
      }

      prevMonth.push(
        <div
          onClick={handleClick}
          key={v4()}
          id={"prev-" + i}
          className={cName}
        >
          {days[prevMonthDays] - i + 2}
        </div>
      );
    }

    let nextMonth = [];
    let fullDays = 35;
    if ([...prevMonth, ...ar].length > 35) {
      fullDays = 42;
    }

    for (let i = 1; i <= fullDays - [...prevMonth, ...ar].length; i++) {
      let cName = "single-number other-month";
      const lastDay = week.lastDay.getTime();
      const lastDayOfMonth = new Date(
        new Date(date).setDate(getDaysInMonth(date))
      );

      if (
        lastDayOfMonth.getTime() <= lastDay &&
        week.firstDay.getMonth() == lastDayOfMonth.getMonth()
      ) {
        cName = "single-number selected-week";
      }

      nextMonth.push(
        <div
          onClick={handleClick}
          key={v4()}
          id={"next-" + i}
          className={cName}
        >
          {i}
        </div>
      );
    }
    return [...prevMonth, ...ar, ...nextMonth];
  };


  const handleOpenWeekPicker = () => {

        setOpen(true)
    

   
  }

  const handleDate = (next?:any) => {
    let localDate = new Date(date);
    if (next) {
      localDate = addMonths(localDate, 1);
    } else {
      localDate = subMonths(localDate, 1);
    }
    setDate(new Date(localDate));
  };

  const handleCloseWeekPicker = () => {
    setOpen(false)
    setFlagWeek(!flagWeek)
  }

  return (
    <div
      className="week-picker-display"
      onBlur={handleCloseWeekPicker}
      onClick={handleOpenWeekPicker}
      tabIndex={0}
      style={{color:'var(--lis-dark)', borderColor:'var(--lis-dark)'}}
    >
      <p>
        {convertDate(week.firstDay)} - {convertDate(week.lastDay)}
      </p>
      {open && (
        <div className={"week-picker-options-op" }>
          <div className="title-week">
            <div onClick={() => handleDate()} className="arrow-container">
              {ArrowLeft}
            </div>
            <span style={{fontFamily:'var(--roboto-medium)',color:'black'}}>{`${months[date.getMonth()]} ${date.getFullYear()}.`}</span>
            <div onClick={() => handleDate(true)} className="arrow-container">
              {ArrowRight}
            </div>
          </div>
          <div className="numbers-container">
            <div className="single-number day">Lun</div>
            <div className="single-number day">Mar</div>
            <div className="single-number day">Mié</div>
            <div className="single-number day">Jue</div>
            <div className="single-number day">Vie</div>
            <div className="single-number day">Sab</div>
            <div className="single-number day">Dom</div>
          </div>
          <div className="numbers-container">{renderDays()}</div>
        </div>
      )}
    </div>
  );
};
